document.addEventListener("DOMContentLoaded", function() {
    const variant_selector = document.querySelectorAll(".bt-card-product .bt-variant-selector fieldset label");
    const pro_v_item = document.querySelectorAll(".product .bt-variant-selector fieldset label");

    variant_selector.forEach(element => {
        element.addEventListener("click", function() {
            console.log(this);
            setTimeout(function() {
                location.reload();
            }, 300);
        });
    });

    pro_v_item.forEach(item => {
        item.addEventListener("click", function() {
            setTimeout(() => {
                                  this.closest("fieldset").querySelector(".bt-product-variant-selected-value").innerHTML = this.getAttribute("data-value");

                if(document.querySelector(".bt-how-to-install-product-id")) {
                    document.querySelector(".bt-how-to-install-product-id").value = this.closest(".product").querySelector(".bt-buy-buttons-container .product-variant-id").value;
                    this.closest("fieldset").querySelector(".bt-product-variant-selected-value").innerHTML = this.getAttribute("data-value");
                }
            }, 300);
        });
    });

    const V_selector = document.querySelectorAll(".bt-variant-dropdown select");
    V_selector.forEach(item => {
        item.addEventListener("change", function() {
            console.log("value", this.value);
          console.log("fieldset");
                  console.log(this.closest("fieldset").querySelector(".bt-product-variant-selected-value"))
            this.closest("fieldset").querySelector("label[data-value='" + this.value + "']").click();
            setTimeout(() => {
                                  this.closest("fieldset").querySelector(".bt-product-variant-selected-value").innerHTML = this.value;

                if(document.querySelector(".bt-how-to-install-product-id")) {
                    document.querySelector(".bt-how-to-install-product-id").value = this.closest(".product").querySelector(".bt-buy-buttons-container .product-variant-id").value;
                  
                    this.closest("fieldset").querySelector(".bt-product-variant-selected-value").innerHTML = this.value;
                }
            }, 300);
        });
    });

  
});

